import axios from '@/axiosInterceptor';
import ENVS from '../../config';
const state = () => ({
  carriers: [],
  myCarriersTotal: 0,
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
  },
  brokerAuthorityNearbyMapHasLoaded: false,
});

// actions
const actions = {
  async getCarrierInsights(
    { commit },
    { page, itemsPerPage } = { page: 1, itemsPerPage: 15 }
  ) {
    const companyId = this.state.users.currentUser?.company?.id;
    try {
      const res = await axios.get(
        process.env.API_MONITOR + `/api/v1/carriers`,
        {
          params: {
            page,
            per_page: itemsPerPage,
            'q[s]': 'latest_active_freight_carrier_insights_count desc',
            'q[subscriptions_company_id_eq]': companyId,
            'q[active_insights_id_not_null]': 1,
            'q[active_insights_is_type_in]':
              'authority_history_gap,broker_authority_nearby',
          },
        }
      );
      commit('setCarriers', res?.data);
      commit('setPagination', res?.headers);
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async getMyCarriers(
    { commit },
    { page, itemsPerPage } = { page: 1, itemsPerPage: 15 }
  ) {
    const companyId = this.state.users.currentUser?.company?.id;

    try {
      const res = await axios.get(
        process.env.API_MONITOR + `/api/v1/carriers`,
        {
          params: {
            page,
            per_page: itemsPerPage,
            'q[subscriptions_company_id_eq]': companyId,
          },
        }
      );

      commit('setMyCarriersTotal', res?.headers);
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  // async getInsightsDetails({ commit }) {
  //   const userID = this.state.users.currentUser.id;
  //   try {
  //     const req = await axios.get(
  //       `${ENVS.API.MONITOR}/api/v1/carriers/${userID}/detail`
  //     );
  //     commit("setInsightsDetails", req.data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // },

  async getSampleInsightsDetails({ commit }) {
    try {
      const req = await axios.get(
        `${ENVS.API.MONITOR}/api/v1/carriers?page=1&per_page=50&q[s]=latest_active_freight_carrier_insights_count desc&q[active_insights_id_not_null]=1&q[active_insights_is_type_in]=authority_history_gap,broker_authority_nearby&q[id_in]=818455,499997,208100,438726,227324,436850,461685,296983,86101,65454,167936,118411,51198,79873,31366,61291,193508,61747,13928,137831,186898,140325,616791,812178,529530,466868,544457,559437,534895,774656,772038,606867,747648`
      );
      commit('setCarriers', req?.data);
    } catch (error) {
      console.error(error);
    }
  },
};

// mutations
const mutations = {
  setCarriers(state, carriers) {
    state.carriers = carriers;
  },
  setMyCarriersTotal(state, headers) {
    state.myCarriersTotal = parseInt(headers.totalitems);
  },
  setPagination(state, headers) {
    state.pagination = {
      currentPage: parseInt(headers.currentpage),
      totalPages: parseInt(headers.totalpages),
      totalRecords: parseInt(headers.totalitems),
    };
  },
  setBrokerAuthorityNearbyMapHasLoaded(state, bool) {
    state.brokerAuthorityNearbyMapHasLoaded = bool;
  },
};

export default {
  state,
  actions,
  mutations,
  namespaced: true,
};
